// import
import SearchIcon from "@mui/icons-material/Search";
import { Grid, Paper, InputBase, IconButton } from "@mui/material";
import React from "react";
import parse from "html-react-parser";
import uuid from "react-uuid";

export const EnhancedTableToolbar = (props) => {
  return (
    <Grid sx={{ flexGrow: 1 }} container spacing={2}>
      <Grid item xs={12} sx={{ width: { xs: "100%", sm: "100%", md: "100%", lg: "100%" } }} className="inspection-toolbar-main">
        <Paper
          elevation={0}
          className={"inspection-search-field"}
          sx={{
            p: "2px 4px",
            display: "flex",
            alignItems: "center",
            width: { xs: "241px", sm: "29.64%", md: "29.64%", lg: "29.64%" },
          }}
        >
          <IconButton sx={{ p: "10px" }} aria-label="search">
            <SearchIcon className="inspection-search-icon" />
          </IconButton>
          <InputBase sx={{ ml: 1, flex: 1, fontSize: "16px" }} placeholder="Search template library" inputProps={{ "aria-label": "search" }} onChange={props.handleSearchFilter} />
        </Paper>
      </Grid>
      <Grid item xs={12}></Grid>
    </Grid>
  );
};
export function descendingComparator(a, b, orderBy) {
  function stripHtmlTags(str) {
    return str.replace(/<[^>]*>?/gm, "");
  }
  if (orderBy === "rating") {
    if (a["summaries"][0]?.summary?.name === null || a["summaries"][0]?.summary?.name === undefined) return 1;
    if (b["summaries"][0]?.summary?.name === null || b["summaries"][0]?.summary?.name === undefined) return -1;
    if (b["summaries"][0]?.summary?.name?.toLowerCase() < a["summaries"][0]?.summary.name?.toLowerCase()) {
      return -1;
    }
    if (b["summaries"][0]?.summary?.name?.toLowerCase() > a["summaries"][0]?.summary?.name?.toLowerCase()) {
      return 1;
    }
    return 0;
  } else {
    if (a[orderBy] === null) return 1;
    if (b[orderBy] === null) return -1;
    const aValue = stripHtmlTags(String(a[orderBy])).toLowerCase();
    const bValue = stripHtmlTags(String(b[orderBy])).toLowerCase();
    const aIsNumber = !isNaN(parseFloat(aValue)) && isFinite(aValue);
    const bIsNumber = !isNaN(parseFloat(bValue)) && isFinite(bValue);

    if ((aIsNumber && bIsNumber) || (!aIsNumber && !bIsNumber)) {
      if (bValue < aValue) {
        return -1;
      }
      if (bValue > aValue) {
        return 1;
      }
      return 0;
    }

    if (aIsNumber && !bIsNumber) {
      return -1;
    }
    if (!aIsNumber && bIsNumber) {
      return 1;
    }
  }
}
export function stableSort(commentListArray, comparator) {
  const stabilizedThis = commentListArray?.map((el, index) => [el, index]);
  stabilizedThis?.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis?.map((el) => el[0]);
}
/** Repair placeholders corrupted when leading '[' was stripped as punctuation. */
export const normalizeDropdownPlaceholderSyntax = (html) =>
  (html ?? "")
    .replace(/(?<!\[)dropdown\s+([a-f0-9-]+)\]/gi, "[dropdown $1]")
    .replace(/(?<!\[)textbox\s+/gi, "[textbox ");

export const replacePlaceholdersWithDropdowns = (htmlString, dropdowns, type, commentUUid) => {
  htmlString = normalizeDropdownPlaceholderSyntax(htmlString);
  htmlString = htmlString?.replace(/Title:[\s\S]*?<br\s*\/?>/gi, "");
  const replaceInputs = (input_text) => {
    let container = document.createElement("div");
    container.innerHTML = input_text;
    container.innerHTML = container.innerHTML.replace(/\[textbox([^\]]*?)\]/g, (match, attributes) => {
      let idMatch = attributes.match(/id:([^;]+);?/);
      let valueMatch = attributes.match(/value:([^;]*);?/);
      let id = idMatch && idMatch[1].trim().length > 30 ? idMatch[1].trim() : uuid();
      let rawValue = valueMatch ? valueMatch[1].trim() : "";
      const safeValue = rawValue.replace(/"/g, '&quot;');
      return `<input id="${id}" value="${safeValue || ""}" title="${safeValue || ""}" class="${type}-input-box" comment_uuid="${commentUUid}" 
        style=" width: 104px !important;
        background-color: #f1f9fe !important;
        height: 24px !important;
        overflow-wrap: break-word !important;
        padding: 1px 17px 3px 6px !important;
        border-radius: 4px !important;
        border: 1px solid #0F75BC !important;
        appearance: none;
        -webkit-appearance: none;
        -moz-appearance: none;
        font-size: 14px !important;
        color: #3B3B3B !important;
        font-style: normal !important;
        font-weight: 600 !important;
        max-width: 200px !important;
        min-width: 104px !important;
        text-overflow: ellipsis !important;
        white-space: nowrap !important;
        margin-left: 4px; !important"/>`;
    });
    return container.innerHTML;
  };
  if (Array?.isArray(dropdowns) && dropdowns?.length > 0) {
    dropdowns.forEach((dropdown) => {
      const placeholder = `\\[dropdown ${dropdown.dropdown_uuid}\\]`;
      const regex = new RegExp(placeholder, "g");
      const inputElement = document.createElement("input");
      let newDropdownValues = dropdown?.dropdowns_values?.values;
      if (newDropdownValues?.length !== 0) {
        newDropdownValues = newDropdownValues?.filter((obj) => !obj?.toUpperCase()?.includes("XXX"));
        if (!newDropdownValues?.find((value) => value?.includes("-----"))) {
          newDropdownValues?.unshift("-------------");
        }
      }
      const newValue = dropdown?.selected_value?.replaceAll('&quot;', '"', 'g') || "";
      inputElement.setAttribute("name", type);
      inputElement.classList.add(`${type}-cl-detail-dropdown`);
      inputElement.setAttribute("value", newValue || "");
      inputElement.setAttribute("title", newValue || "");
      inputElement.setAttribute("id", `${dropdown.dropdown_uuid}`);
      inputElement.setAttribute("comment_uuid", commentUUid);
      inputElement.setAttribute("list_guid", dropdown.list_guid);
      const newSelectUuid = dropdown.dropdown_uuid;
      const valuesArray = dropdown?.dropdowns_values ?? [];
      const encodedArray = JSON.stringify(valuesArray)?.replace(/"/g, '&quot;');
      const buttonHTML = ` <button
          id="dropdownIcon_${newSelectUuid}"
          type="button"
          data-dropdown-id="${newSelectUuid}"
          onclick="window.openDropdown('${newSelectUuid}', event, ${encodedArray}, '${commentUUid}', '${dropdown.list_guid}')"
          style="background-color: #f1f9fe;
            width: 28px;
            height: 28px !important;
            border: 1px solid #4282e2;
            border-right: 1px solid #4282e2;            
            vertical-align: middle;
            margin-left: -3px;
            font-size: 14px;
            color: #4282e2;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            border-radius: 0px 4px 4px 0px; 
            ">
          ▾
        </button>`;
      const wrappedHTML = `<span style="display: inline-flex; align-items: center;">${inputElement.outerHTML}${buttonHTML}</span>`;
      htmlString = htmlString?.replace(regex, wrappedHTML);
    });
  } else {
    const regexPlainDropdown = /\[dropdown ([a-f0-9\-]+)\]/g;
    htmlString = htmlString?.replace(regexPlainDropdown, (match, dropdownId) => {
      const newSelectUuid = dropdownId;
      const inputElement = document.createElement("input");
      inputElement.setAttribute("name", type);
      inputElement.classList.add(`${type}-cl-detail-dropdown`);
      inputElement.setAttribute("comment_uuid", commentUUid);
      inputElement.setAttribute("id", `${newSelectUuid}`);
      inputElement.setAttribute("value", "");
      const buttonHTML = `<button  type="button"
        onclick="window.openDropdown('${newSelectUuid}', event, null, '${commentUUid}')"
        style="background-color: #f1f9fe;
          width: 28px;
          height: 28px !important;
          border: 1px solid #4282e2;
          border-right: 1px solid #4282e2;
          vertical-align: middle;
          margin-left: -3px;
          font-size: 14px;
          color: #4282e2;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          border-radius: 0px 4px 4px 0px;">
        ▾
      </button>`;
      const wrappedHTML = `<span style="display: inline-flex; align-items: center;">${inputElement.outerHTML}${buttonHTML}</span>`;
      return wrappedHTML;
    });
  }
  return replaceInputs(htmlString);
};

export function preprocessHTMLContent(htmlContent) {
  const textContent = htmlContent?.replace(/<(?!input\b)[^>]+>/gi, "");
  const normalizedText = textContent?.replace(/&nbsp;/g, " ");
  return normalizedText?.trim();
}
const LEADING_WHITESPACE_AND_PUNCT = /^[\s\u00A0.,;:!?\-–—_'"`()*[\]{}…《》「」]+/;
const LEADING_REGULAR_WHITESPACE = /^[ \t\n\r\f\v]+/;
const LEADING_PUNCTUATION = /^[.,;:!?\-–—_'"`()*[\]{}…《》「」]+/;

/** Collapse normal whitespace only — keep non-breaking space (\u00A0 / &nbsp;). */
export const collapseFormattingWhitespace = (html) =>
  (html ?? "").replace(/[ \t\n\r\f\v]+/g, " ");

/** Normalize \u00A0 chars to &nbsp; entity for stable API payloads. */
export const serializeNbspEntities = (html) =>
  (html ?? "").replace(/\u00A0/g, "&nbsp;");

const isInsideInlineControlMarker = (textNode) => {
  let el = textNode.parentElement;
  while (el) {
    if (el.classList?.contains("froala-dynamic-input-wrapper")) return true;
    if (el.tagName === "SPAN") {
      const t = el.textContent ?? "";
      if (/\[textbox\s/i.test(t) || /\[dropdown\s/i.test(t) || /^textbox\s/i.test(t) || /^dropdown\s/i.test(t)) {
        return true;
      }
    }
    if (el.tagName === "INPUT" || el.tagName === "SELECT") return true;
    el = el.parentElement;
  }
  return false;
};

const isControlPlaceholderText = (value) => {
  const t = (value ?? "").trim();
  return /^\[(?:dropdown|textbox)\s/i.test(t) || /^(?:dropdown|textbox)\s/i.test(t);
};

const hasVisibleTextContent = (value) =>
  (value ?? "").replace(/[ \t\n\r\f\v\u00A0]/g, "").length > 0;

/** True when node is only &nbsp;/\u00A0 — never strip or collapse these after inputs. */
const isPreservedNbspText = (value) =>
  (value ?? "").length > 0 && !hasVisibleTextContent(value);

const isNbspOnlyText = (value) => /^[\u00A0]+$/.test(value ?? "");

const isImmediatelyAfterDynamicInput = (textNode) => {
  let prev = textNode.previousSibling;
  while (prev) {
    if (prev.nodeType === Node.ELEMENT_NODE) {
      if (prev.classList?.contains("froala-dynamic-input-wrapper")) return true;
      if (prev.tagName === "INPUT") return true;
      return false;
    }
    if (prev.nodeType === Node.TEXT_NODE) {
      const t = prev.textContent ?? "";
      if (isNbspOnlyText(t) || /^[ \t\n\r\f\v\u00A0]*$/.test(t)) {
        prev = prev.previousSibling;
        continue;
      }
      if (hasVisibleTextContent(t)) return false;
    }
    prev = prev.previousSibling;
  }
  return false;
};

/** Plain text (e.g. titles): drop leading spaces and punctuation such as "..". */
export function stripLeadingPunctuationFromPlainText(text) {
  if (text == null || text === "") return text;
  const normalized = String(text).trim();
  if (isControlPlaceholderText(normalized)) return normalized;
  return normalized.replace(LEADING_WHITESPACE_AND_PUNCT, "");
}

/** Froala HTML: strip leading punctuation from first visible text; preserve &nbsp; nodes. */
export function stripLeadingPunctuationFromHtml(html) {
  if (html == null || typeof html !== "string") return "";
  if (html.trim() === "") return html;
  try {
    const tpl = document.createElement("template");
    tpl.innerHTML = html.trim();
    const walker = document.createTreeWalker(tpl.content, NodeFilter.SHOW_TEXT, null);
    let tn = walker.nextNode();
    while (tn) {
      const v = tn.nodeValue;
      if (v == null) {
        tn = walker.nextNode();
        continue;
      }
      if (isInsideInlineControlMarker(tn)) {
        tn = walker.nextNode();
        continue;
      }
      if (isControlPlaceholderText(v)) {
        tn = walker.nextNode();
        continue;
      }
      if (isImmediatelyAfterDynamicInput(tn) && isPreservedNbspText(v)) {
        tn = walker.nextNode();
        continue;
      }
      if (!hasVisibleTextContent(v)) {
        tn = walker.nextNode();
        continue;
      }
      const nextVal = v
        .replace(LEADING_REGULAR_WHITESPACE, "")
        .replace(LEADING_PUNCTUATION, "");
      if (nextVal !== v) tn.nodeValue = nextVal;
      break;
    }
    return tpl.innerHTML;
  } catch {
    return html;
  }
}

export function filterSelectTag(htmlText) {
  if (!htmlText) return "";
  htmlText = htmlText
    .replace(/<undefined>/gi, "<p>")
    .replace(/<\/undefined>/gi, "</p>");
  var tempContainer = document.createElement("div");
  var container = document.createElement("p");
  container.innerHTML = htmlText;
  while (tempContainer.firstChild) {
    container.appendChild(tempContainer.firstChild);
  }
  var spans = container.querySelectorAll("span[id^='dropdown_']");
  spans.forEach((span) => {
    var spanId = span.id.replace("dropdown_", "").trim();
    if (spanId) {
      span.outerHTML = `[dropdown ${spanId}]`;
    }
  });
  var inputs = container.querySelectorAll("input");
  inputs.forEach((input) => {
    const escapeHTML = (str) => str.replace(/"/g, "&quot;")
    let id = input.id ? `id:${input.id}; ` : "";
    let value = input.value ? `value:${escapeHTML(input.value)}; ` : "";
    let placeholder = `[textbox ${id}${value}]`.trim();
    const wrapper = input.closest(".froala-dynamic-input-wrapper");
    if (wrapper) {
      wrapper.outerHTML = placeholder;
    } else {
      input.outerHTML = placeholder;
    }
  });
  container.innerHTML = serializeNbspEntities(collapseFormattingWhitespace(container.innerHTML))
    .replace(/<div>[ \t\n\r\f\v]*<\/div>/g, "")
    .replace(/<p>([ \t\n\r\f\v]|<br\s*\/?>)*<\/p>/g, "")
    .trim();
  return container.innerHTML;
}

// export function filterSelectTagIntro(htmlText) {
//   if (!htmlText) return "";
//   var container = document.createElement("div");
//   container.innerHTML = htmlText;
//   var spans = container.querySelectorAll("span[id^='[dropdown']");
//   spans.forEach((span) => {
//     var spanId = span.id.match(/\[dropdown\s(.*?)\]/)?.[1];
//     if (spanId) {
//       var placeholder = `[dropdown ${spanId}]`;
//       span.outerHTML = placeholder;
//     }
//   });
//   container.innerHTML = container.innerHTML.replace(/\s+/g, " ").trim();
//   return container.innerHTML;
// }

export function filterSelectTagIntro(htmlText) {
  if (!htmlText) return "";
  try {
    var container = document.createElement("div");
    container.innerHTML = htmlText;
    var spans = container.querySelectorAll("span[id^='dropdown_']");
    spans.forEach((span) => {
      var spanId = span.id.replace("dropdown_", "").trim();
      if (spanId) {
        span.outerHTML = `[dropdown ${spanId}]`;
      }
    });
    var inputs = container.querySelectorAll("input");
    inputs.forEach((input) => {
      const escapeHTML = (str) => str.replace(/"/g, "&quot;");
      let id = input.id ? `id:${input.id}; ` : "";
      let value = input.value ? `value:${escapeHTML(input.value)}; ` : "";
      let placeholder = `[textbox ${id}${value}]`.trim();
      const wrapper = input.closest(".froala-dynamic-input-wrapper");
      if (wrapper) {
        wrapper.outerHTML = placeholder;
      } else {
        input.outerHTML = placeholder;
      }
    });
    return serializeNbspEntities(collapseFormattingWhitespace(container.innerHTML)).trim();
  } catch (error) {
    console.error("Error in filterFroalaDropdowns:", error);
    return htmlText;
  }
}


export const decodeEntities = (encodedString) => {
  const textarea = document.createElement("textarea");
  textarea.innerHTML = encodedString;
  return textarea.value;
};